import { LegalArea } from "@/core/types/types";
import { datadogRum, RumEvent } from "@datadog/browser-rum";
import Cookies from "js-cookie";

interface DataDogInitConfig {
  environment: string;
  version: string;
  legalArea: LegalArea;
  processInstanceId: string;
  definitionName: string;
}

let isUserSet = false;

function init(config: DataDogInitConfig) {
  datadogRum.init({
    applicationId: "a21f64be-f001-418b-a543-ce3d30a39421",
    clientToken: "pube1d5c0460fa21f100568da1f951e852c",
    site: "datadoghq.eu",
    service: "airspeed-claim-check",
    env: config.environment,
    version: config.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: getSampleRate(config.legalArea),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "allow",
    trackViewsManually: true,
    beforeSend,
  });

  datadogRum.setUser({
    id: config.processInstanceId,
  });

  onProcessInstanceCreated(config.processInstanceId, config.definitionName);

  datadogRum.startSessionReplayRecording();
}

function beforeSend(event: RumEvent) {
  if (event.type === "error") {
    const processCookie = Cookies.get("process");
    event.context = { ...event.context, process: processCookie };
  }
}

function reportError(error: Error, context?: object) {
  datadogRum.addError(error, context);
}

function pushVirtualPageView(
  pageViewTitle: string,
  definitionName: string | undefined,
  version: string
) {
  if (!isUserSet) {
    const processId = Cookies.get("process");
    if (processId) {
      setUser(processId);
      isUserSet = true;
    }
  }
  datadogRum.startView({
    name: `/claimcheck-airspeed/${definitionName}/${pageViewTitle}`,
    service: "airspeed-claim-check",
    version,
  });
}

function setUser(userId: string) {
  datadogRum.setUser({
    id: userId,
  });
}

function onProcessInstanceCreated(
  processInstanceId: string,
  definitionName: string
) {
  datadogRum.addAction("New process instance created", {
    id: processInstanceId,
    "definition-name": definitionName,
  });
}

function getSampleRate(legalArea: LegalArea) {
  if (legalArea === LegalArea.MIE) return 100;
  return 10;
}

export { init, reportError, pushVirtualPageView, setUser };
